import ReactPlayer from "react-player";
import { useEffect, useRef } from "react";

/**
 * Publishes the ready ReactPlayer to the consumer (TimelinePlayerContext).
 * Clears only when the local instance is gone (source reset) or on unmount —
 * not on every player-identity transition cleanup (that raced ahead of publish
 * and left context.player undefined so seeks no-oped).
 */
export default function useOnReadyHandler(
  player: ReactPlayer | undefined,
  canPlay: boolean,
  onReady?: (player: ReactPlayer | undefined) => void,
) {
  const onReadyRef = useRef(onReady);
  onReadyRef.current = onReady;

  useEffect(() => {
    if (player && canPlay) {
      onReadyRef.current?.(player);
      return;
    }
    if (!player) {
      onReadyRef.current?.(undefined);
    }
  }, [player, canPlay]);

  useEffect(() => {
    return () => {
      onReadyRef.current?.(undefined);
    };
  }, []);
}
